import { IDataTableHeader } from '@typings/components';

export const AUCTIONS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Auction / Account', align: 'left',   width: '20%' },
  { label: 'Status / VIN #',    align: 'left',   width: '20%' },
  { label: 'Actions',           align: 'center', width: '15%' },
  { label: 'Watches',           align: 'center', width: '6%' },
  { label: 'Views',             align: 'center', width: '6%' },
  { label: 'Bids',              align: 'center', width: '6%' },
  { label: 'Current Bid',       align: 'center', width: '9%' },
  { label: '% WSale',           align: 'center', width: '9%' },
  { label: '% Retail',          align: 'center', width: '9%' },
];
